import * as types from '../../actions/actionTypes';
import initialState from '../initialState';
import moment from 'moment';
import DateHelper from '../../components/helpers/DateHelper';

export default function jobReducer(state = initialState.job, action) {
    switch (action.type) {
        case types.GET_DEFAULT_JOB_STATE:
            return getDefaultState();
        case types.CREATE_JOB_SUCCESS:
            return getDefaultState();
        case types.LOAD_JOB_SUCCESS:
            let formatedJob = Object.assign({}, state, action.job);

            formatedJob.status = +formatedJob.status;

            let minDate = moment(new Date()).add(1, 'days').unix();
            let endTime = formatedJob.endTime;
            if(!formatedJob.endTime || minDate > endTime) {
                formatedJob.endTime = minDate;
            }

            return formatedJob;
        default:
            return state;
    }
}

function getDefaultState() {
    return {
        jobId: null,
        isCommentsAllowed: true,
        status: 1,
        title: '',
        content: '',
        categoryId: '',
        startTime: moment().unix(),
        endTime: moment(DateHelper.getTomorrow()).unix(),
        regionId: '',
        workingTimeId: '',
        contactPersonId: null
    };
}


// WEBPACK FOOTER //
// ./web/src/reducers/job/jobReducer.js